(function (){
    'use strict';

    angular
        .module('edufindme', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'vAccordion',
            'ngAnimate',
            'ui.footable',
            'selectize',
            'daterangepicker'
        ]);
})();